import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/vehicle-makes')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/vehicle-makes-page')),
  staticData: { titleKey: 'vehicleMakes' },
});
